"use client"
import { useEffect } from 'react'

export function useReveal(selector: string = '.reveal', rootMargin: string = '0px 0px -10% 0px') {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>(selector))
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.dataset.reveal = 'in')
      return
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          (e.target as HTMLElement).dataset.reveal = 'in'
          io.unobserve(e.target)
        }
      })
    }, { rootMargin, threshold: 0.15 })
    els.forEach(el => io.observe(el))
    return () => io.disconnect()
  }, [selector, rootMargin])
}
